import React, { Component } from 'react';
import { Trans } from "react-i18next";

import DropIn from "braintree-web-drop-in-react";
import axios from 'axios';
import Loader from 'react-loader-spinner';

import "../../config/i18n";
import { withTranslation } from "react-i18next"; 

import ls from "local-storage"; 
import { options } from "../../config/options"; 

class Boostpayment extends Component { 
  instance;

  state = {
    modal: false,
    buybutton: 'buybutton',
    clientToken: null, api_url: localStorage.getItem('api_url'),
    lang: ls.get('LangKeySet') || options[0],
    langKey: ls.get('LangValue'), 
     selected_superlikepremium:'',
    price:'',
    currency:'',
  };

  async componentDidMount() {
     if(!this.props || this.props.location.package_id===undefined){
         this.props.history.push("/app/Profile"); 
         return false;
        }
       
        let selected_superlikepremium=this.props.location.package_id || JSON.parse(localStorage.getItem('selected_superlikepremium'));
        let price=this.props.location.price || JSON.parse(localStorage.getItem('superlikepremium_price'));
        let currency=this.props.location.currency || JSON.parse(localStorage.getItem('currency'));
         console.log('package_id',this.props.location.package_id+"price="+this.props.location.price+"cur="+this.props.location.currency);
         this.setState({
            selected_superlikepremium:selected_superlikepremium,
            price:price,
            currency:currency
         });    
    axios.get(this.state.api_url + `generateclienttoken`)
      .then(res => {
        // console.log(res.data);
        if (res.data.token != null) {
          this.setState({
            clientToken: res.data.token
          });
        }

        if (!this.state.clientToken) {
          this.setState({
            buybutton: 'buybutton'
          });

        } else {
          setTimeout(() => {
            this.setState({
              buybutton: 'buybuttonshow',

            });
          }, 2000);
        }
      })

    // If returned as JSON string


  }

  componentWillMount() {

    //alert(this.state.buybutton) 
  }

  async buy() {
    //console.log(this.instance);
    
    // Send the nonce to your server
    const { nonce } = await this.instance.requestPaymentMethod();
    if(nonce){
      this.setState({
        buybutton: 'buybutton'
      });
    }
    var payment = new FormData();
    payment.set('pay_nonce', nonce);
    //payment.set('price', JSON.parse(localStorage.getItem('superlikepremium_price')));
    payment.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
    //payment.set('superlike_id', JSON.parse(localStorage.getItem('selected_superlikepremium')));  
    //payment.set('currency_code', JSON.parse(localStorage.getItem('currency')));
    payment.set('language', this.state.langKey);
    payment.set('superlike_id', this.state.selected_superlikepremium);
    payment.set('price', this.state.price);
    payment.set('currency_code', this.state.currency);    
    
    axios({
      method: 'post',
      url: this.state.api_url+'webpaysuperlike',
      data: payment,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .then(res => {
        
       // console.log("premium boost "+res.data);
        localStorage.setItem('selected_superlikepremium', '');
        localStorage.setItem('superlikepremium_price', ''); 
        if (res.data.status === "true") { 
          localStorage.setItem('superlike_premium_popup', '1');  
          this.props.history.push("/app/Profile")

        } else {
          this.props.history.push("/app/Profile")
        }
      })
  }

  render() {
    var style = {
      zIndex: 10,
      backgroundColor: "white",
      height: "100vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      //width:"100%",
      overflowY: "hidden" 
    };
    if (this.state.clientToken) {
      return (
        <div className="peopleShowHolder">
          <div style={{
            display: "flex",
            flexDirection: "column",
            height: "90vh",
            justifyContent: "center"
          }}>

            <DropIn
              options={{ authorization: this.state.clientToken }}
              onInstance={instance => (this.instance = instance)}
            />
            {this.state && this.state.clientToken &&
              <button className={this.state.buybutton} onClick={this.buy.bind(this)}><Trans i18nKey="Buy"></Trans></button>
            }
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="loder-icon">
            <div style={style} id="loader">
              <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
            </div>
          </div>
        </div>
      );

    }
  }
} 
export default withTranslation("translations")(Boostpayment); 